<template>
  <div :class="{
    'color-customizer cursor-pointer': true,
    'colors-extracted': useExtractedColors
  }">
    <label v-if="label">{{label}}</label>
    <Popper trigger="click" :options="{placement: 'bottom'}" @show="show = true" @hide="show = false" @document-click="show = false">
      <div class="popper">
        <Sketch v-if="show" :value="color" :disableAlpha="true" :presetColors="presetColors" @input="onInput" />
      </div>
      <div slot="reference">
        <input class="form-control text-center d-block cursor-pointer" :style="{ background: color, borderColor: borderColor(color), color: textColor(color), fontSize: '14px' }" readonly :value="color === 'inherit' ? 'Inherit' : 'Tap to change'" />
      </div>
    </Popper>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Popper from 'vue-popperjs'
import Sketch from 'vue-color/src/components/Sketch'

import 'vue-popperjs/dist/vue-popper.css'

import update from '@/mixins/update'
import { darken, mostReadable } from '@/utils/color'

const DEFAULT_PRESET = [
  '#d0021b', '#f5a623', '#f8e71c', '#8b572a', '#7ed321',
  '#417505', '#bd10e0', '#9013fe', '#4a90e2', '#50e3c2',
  '#b8e986', '#000000', '#4a4a4a', '#9b9b9b', '#ffffff'
]

export default {
  mixins: [ update ],
  props: {
    category: String,
    type: String,
    label: String,
    value: String,
    setTextColor: {
      type: Boolean,
      default: false
    },
    setSameTextColor: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: String,
      default: '#fff'
    }
  },
  components: {
    Sketch,
    Popper
  },
  data: function () {
    return {
      show: false,
      useExtractedColors: false
    }
  },
  created: function () {
    if (!this.vAuto.colors) {
      this.useExtractedColors = false
      return
    }

    const colors = [
      ...(this.vAuto.colors.dark || []),
      ...(this.vAuto.colors.light || []),
      ...(this.vAuto.colors.gray || [])
    ]

    if (colors.length === 0) {
      this.useExtractedColors = false
      return
    }

    this.useExtractedColors = colors.slice(0, 16)
  },
  computed: {
    ...mapState([ 'amptheme', 'vAuto' ]),
    color: function () {
      let val

      if (this.category) {
        if (this.amptheme[this.category]) {
          val = this.amptheme[this.category][this.type] || this.defaultValue
        } else {
          val = this.defaultValue
        }
      } else {
        val = this.value
      }

      if (val === 'transparent') return '#fff'

      return val
    },
    presetColors: function () {
      if (!this.useExtractedColors) return DEFAULT_PRESET

      return this.useExtractedColors
    }
  },
  methods: {
    borderColor: darken,
    textColor: function (color) {
      if ([ 'inherit', 'transparent' ].includes(color)) {
        color = '#fff'
      }

      return mostReadable(color)
    },
    onInput: function (event) {
      const color = event.hex.toLowerCase()

      if (this.category) {
        this.updateAMPTheme(this.category, { [this.type]: color })

        if (this.setTextColor) {
          this.updateAMPTheme(this.category, { color: mostReadable(color) })
        }

        if (this.setSameTextColor) {
          this.updateAMPTheme(this.category, { color: color })
        }
      }

      this.$emit('input', color)
    }
  }
}
</script>

<style lang="scss">
.popper {
  padding: 0!important;
  box-shadow: none!important;
  border: 0!important;

  .popper__arrow {
    display: none;
  }
}

.vc-input__input {
  text-align: center;
  padding-left: 0!important;
}

.colors-extracted {
  .vc-sketch.vc-sketch__disable-alpha {
    display: flex;
    flex-direction: column;
    padding-top: 0;

    .vc-sketch-field {
      padding-bottom: 6px;
    }

    .vc-sketch-presets {
      border-top: 0;
      border-bottom: 1px solid #eee;
      margin-bottom: 10px;
      order: -1;

      &:before {
        display: block;
        width: 100%;
        content: 'Colors Extracted From Your Store';

        text-align: center;
        font-size: 11px;
        color: #222;
        padding-bottom: 7px;
        text-transform: capitalize;

        margin-left: -5px;
      }
    }
  }
}
</style>
